function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgLeafOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 2.5a.5.5 0 0 0-.675-.469c-.737.275-1.715.36-2.88.462l-.13.012c-1.19.104-2.526.231-3.785.648-1.531.506-2.94 1.55-3.76 3.092-.805 1.51-1.02 3.449-.303 5.73-.345.818-.467 1.516-.467 2.027a.5.5 0 0 0 1 0c0-.346.084-.877.346-1.534.337-.023.717-.016 1.158-.006h.026c.549.012 1.173.025 1.842-.03 1.377-.11 2.943-.505 4.608-1.75 1.5-1.12 2.246-2.816 2.622-4.371.378-1.56.398-3.044.398-3.811ZM4.353 11.453c.219 0 .441.004.663.009h.018c.558.012 1.14.024 1.758-.026 1.227-.1 2.604-.444 4.09-1.555 1.236-.924 1.899-2.36 2.248-3.805.262-1.081.339-2.132.361-2.906-.731.17-1.562.242-2.39.313l-.2.018c-1.198.105-2.424.226-3.557.601-1.323.438-2.508 1.33-3.192 2.613-.55 1.032-.793 2.352-.487 3.952.916-1.421 2.486-3.04 5.078-4.596a.5.5 0 0 1 .514.858c-2.646 1.587-4.114 3.201-4.904 4.524Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgLeafOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgLeafOutlinedIcon);
export default Memo;